import { NoteDto } from "services/apis/types/order/NoteDto";
import React, { useContext } from "react";
import FormatDateTime from "components/framework/date/FormatDateTime";
import classNames from "classnames";
import { NoteOrigin } from "services/apis/types/order/NoteOrigin";
import { NoteVisibility } from "services/apis/types/order/NoteVisibility";
import { EnvironmentUtil } from "services/util/EnvironmentUtil";
import { AppContext } from "services/appContext/AppContext";
import { PermissionType } from "services/authorization/PermissionType";

const isMixNetworkUrl = EnvironmentUtil.isMixNetwork;

type Props = {
  noteDto: NoteDto;
};

export default function NoteBlock(props: Props) {
  const { appContext } = useContext(AppContext);
  const isUserAdmin = appContext.localStorageInfo.user?.permissions.find(
    (value) => value === PermissionType.Admin
  );

  // Note text handling: convert to bullet list if multiple lines
  const note = props.noteDto.note || "";
  const lines = note.split("\r\n").filter((line) => line.trim() !== "");

  return (
    <div className="timeline-block">
      <span className="timeline-step badge-success">
        <i
          className={classNames({
            "ni ni-bell-55": props.noteDto.origin === NoteOrigin.System,
            "far fa-comment-dots":
              props.noteDto.origin === NoteOrigin.User &&
              props.noteDto.visibility === NoteVisibility.Private,
            "fas fa-megaphone":
              props.noteDto.origin === NoteOrigin.User &&
              props.noteDto.visibility === NoteVisibility.Public,
          })}
        />
      </span>
      <div className="timeline-content">
        <small className="text-muted font-weight-bold">
          <FormatDateTime utcDate={props.noteDto.createdAt} />
        </small>
        <h5 className="mt-3 mb-0">{props.noteDto.title}</h5>
        {lines.length > 1 ? (
          <ul className="text-sm mt-1 mb-0" style={{ paddingLeft: "1.15em", margin: 0 }}>
            {lines.map((line, idx) => (
              <li key={idx}>{line}</li>
            ))}
          </ul>
        ) : (
          <p className="text-sm mt-1 mb-0">{lines[0]}</p>
        )}
        <small className="mt-3 text-muted">
          -{" "}
          {isMixNetworkUrl &&
          !isUserAdmin &&
          (props.noteDto.createdBy === "PortControl" ||
          (
          props.noteDto.isAdmin &&
          props.noteDto.visibility === NoteVisibility.Public &&
          props.noteDto.createdBy.includes("@")))
            ? "System"
            : props.noteDto.createdBy}
        </small>
      </div>
    </div>
  );
}
